var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgMaximize = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24,
  fill: "#F2F4F8",
  rx: 4
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#0C9BAB",
  d: "M22.5 2.625v6.75a1.127 1.127 0 0 1-1.922.797l-1.875-1.875L8.297 18.703l1.875 1.875a1.127 1.127 0 0 1-.797 1.922h-6.75A1.122 1.122 0 0 1 1.5 21.375v-6.75a1.127 1.127 0 0 1 1.922-.797l1.875 1.875L15.703 5.297l-1.875-1.875a1.127 1.127 0 0 1 .797-1.922h6.75c.623 0 1.125.502 1.125 1.125Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#0C9BAB",
  d: "M2.625 1.5h6.75a1.127 1.127 0 0 1 .797 1.922L8.297 5.297 12 9l-3 3-3.703-3.703-1.875 1.875A1.127 1.127 0 0 1 1.5 9.375v-6.75c0-.623.502-1.125 1.125-1.125ZM12 15l3-3 3.703 3.703 1.875-1.875a1.127 1.127 0 0 1 1.922.797v6.75c0 .624-.502 1.125-1.125 1.125h-6.75a1.127 1.127 0 0 1-.797-1.922l1.875-1.875L12 15Z",
  opacity: 0.4
})));
export default SvgMaximize;